import { render } from "./stepAllegatiOut.vue?vue&type=template&id=20f08320&ts=true"
import script from "./stepAllegatiOut.vue?vue&type=script&lang=ts"
export * from "./stepAllegatiOut.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__